import { render, staticRenderFns } from "./superAdminLayout.vue?vue&type=template&id=03ce22b3&scoped=true"
import script from "./superAdminLayout.vue?vue&type=script&lang=js"
export * from "./superAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./superAdminLayout.vue?vue&type=style&index=0&id=03ce22b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce22b3",
  null
  
)

export default component.exports